<template>
  <div class="form-base">
    <v-row>
      <v-col cols="6">
        <DadataOrgField
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Полное наименование"
          outlined
          :suggestions="suggestions"
          field="name"          
          @suggest="onSelect"              
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>

      <v-col cols="6">
        <DadataOrgField
          v-model="v.ogrn.$model"
          :errorMessages="getValidationErrorText(v.ogrn)"
          mask="#############"
          label="ОГРН"
          outlined
          :suggestions="suggestions"
          field="ogrn"          
          @suggest="onSelect"              
        />
      </v-col>
      <v-col cols="6">
        <DadataOrgField
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          mask="##########"
          label="ИНН"
          outlined
          :suggestions="suggestions"
          field="inn"          
          @suggest="onSelect"              
        />
      </v-col>

      <v-col cols="12">
        <div class="form-base__title">
          Лицо, действующее от имени юридического лица без доверенности
        </div>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneeLastName.$model"
          :errorMessages="getValidationErrorText(v.assigneeLastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneeName.$model"
          :errorMessages="getValidationErrorText(v.assigneeName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneePatronymic.$model"
          :errorMessages="getValidationErrorText(v.assigneePatronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model.trim="v.assigneeSnils.$model"
          :errorMessages="getValidationErrorText(v.assigneeSnils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  EMAIL,
  EMOJI,
  getValidationErrorText,
  INN_ROD,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  OGRN,
  PERSON_NAME,
  SNILS_ROD,
} from '@/utils/validate';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import DadataOrgField from '@/components/base/DadataOrgField';

export const proxyTrusteeOrganizationModel = {
  name: '',
  email: '',
  ogrn: '',
  inn: '',
  assigneeLastName: '',
  assigneeName: '',
  assigneePatronymic: '',
  assigneeSnils: '',
};

export const proxyTrusteeOrganizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
  ogrn: {
    required,
    minLength: minLength(13),
    OGRN,
  },
  inn: {
    minLength: minLength(10),
    INN: INN_ROD,
  },
  assigneeLastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneeName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneePatronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneeSnils: {
    required,
    minLength: minLength(MinLength.SNILS),
    SNILS: SNILS_ROD,
  },
};

export default {
  name: 'ProxyTrusteeOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    DadataOrgField,
  },  
  data: () => ({
    suggestions: [],
    getValidationErrorText,
  }),
  methods: {
    onSelect: function (item) {
      this.suggestions = [item];
      this.v.name.$model = item.name;
      this.v.inn.$model = item.inn;
      this.v.ogrn.$model = item.ogrn;
      this.v.email.$model = item.email;
    }
  }  
};
</script>
